'use client';

import { useState, Suspense, useEffect } from 'react';
import Image from 'next/image';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';

export default function LoginAuthenticationInteractive() {
  const [showSignUp, setShowSignUp] = useState(false);

  // Force light theme on login page (prevent dark class on html from making page black)
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.style.backgroundColor = '#fff9f3';
  }, []);

  return (
    <div className="min-h-screen flex flex-col text-slate-900 font-body" style={{ backgroundColor: '#fff9f3' }}>
      {/* Header: match landing page logo sizing and global style */}
      <header className="bg-white/95 backdrop-blur shrink-0 border-b border-slate-200/80 sticky top-0 z-10">
        <div className="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center h-[4.356rem]" aria-label="TallyMedicare home">
            <Image
              src="/tallymedicare-lockup.png"
              alt="TallyMedicare"
              width={262}
              height={71}
              className="h-[4.356rem] w-auto object-contain"
              priority
            />
          </a>
          <a
            href="/"
            className="text-[15px] font-medium text-slate-600 hover:text-[var(--color-primary)] transition-colors"
          >
            Back to home
          </a>
        </div>
      </header>

      {/* Centered sign in / sign up form */}
      <main className="flex-1 flex flex-col items-center justify-center px-4 py-12 md:py-16">
        <section id="auth" className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(0,0,0,0.08)] border border-slate-200/80 p-8">
            <div className="mb-6">
              {showSignUp ? (
                <>
                  <h1 className="text-[28px] md:text-[30px] font-bold text-[#002b1b] mb-3 leading-tight">
                    Create your Tally account
                  </h1>
                  <p className="text-slate-600 text-[15px] leading-relaxed">
                    Use the same email you use with your carriers so we can match your commissions.
                  </p>
                </>
              ) : (
                <>
                  <h1 className="text-[28px] md:text-[30px] font-bold text-[#002b1b] mb-3 leading-tight">
                    Sign in to Tally
                  </h1>
                  <p className="text-slate-600 text-[15px] leading-relaxed">
                    Use the same email you use with your carriers so we can match your commissions.
                  </p>
                </>
              )}
            </div>

            {showSignUp ? (
              <SignUpForm onBackToLogin={() => setShowSignUp(false)} />
            ) : (
              <Suspense fallback={<div className="text-sm text-slate-500">Loading…</div>}>
                <LoginForm onShowSignUp={() => setShowSignUp(true)} />
              </Suspense>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}
